import { useQuery } from '@tanstack/react-query'

import type { BackendQueryOptions } from './api'
import { fetchBackendJson } from './api'

export interface KdkAprHistory {
  time: number
  apr: number
}

export interface KdkAprResponse {
  currentApr: number
  history: KdkAprHistory[]
}

export type KdkAprQueryParams = {
  resolution: string
  startTime: number
  endTime: number
}

type KdkAprQueryOptions = BackendQueryOptions<KdkAprResponse>

export const kdkQueryKeys = {
  apr: (params: KdkAprQueryParams) => ['kdk', 'apr', params.resolution, params.startTime, params.endTime] as const,
}

const fetchKdkApr = async (params: KdkAprQueryParams, signal?: AbortSignal): Promise<KdkAprResponse> => {
  const searchParams = new URLSearchParams({
    resolution: params.resolution,
    startTime: params.startTime.toString(),
    endTime: params.endTime.toString(),
  })

  return fetchBackendJson<KdkAprResponse>(`/kdk/apr?${searchParams.toString()}`, { method: 'GET', signal })
}

export const useGetKdkAprQuery = (params: KdkAprQueryParams, options?: KdkAprQueryOptions) => {
  const {
    skip,
    enabled: optionEnabled,
    queryKey,
    retry = false,
    refetchOnWindowFocus = false,
    ...queryOptions
  } = options ?? {}
  const enabled = (optionEnabled ?? true) && !skip

  return useQuery<KdkAprResponse, Error>({
    queryKey: queryKey ?? kdkQueryKeys.apr(params),
    queryFn: ({ signal }) => fetchKdkApr(params, signal),
    enabled,
    retry,
    refetchOnWindowFocus,
    ...queryOptions,
  })
}
